import { Component } from "preact";
import queryString from "query-string";
import React from "react";
import CMSComponent from "../../components/CMSComponent";
import CallToAction from "../../components/layout/CallToAction";
import ContentBlock from "../../components/layout/ContentBlock";
import Layout from "../../components/layout/Layout";
import SearchComponent from "../../components/search/SearchComponent";
import { updateTitle } from "../../utils/BrowserUtils";
import Categories from "../../components/layout/Categories";

class SearchResultsPage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    updateTitle("Search");
  }

  render() {
    const { content } = this.props;
    if (content && content.widget) {
      return <SearchComponent {...this.props} isWidget={true} />;
    }
    return (
      <Layout>
        <div style={{ backgroundColor: "#f9f9fa" }}>
          <SearchComponent {...this.props} />
          <ContentBlock color="white" sidePad={false}>
            <Categories />
          </ContentBlock>
          <CallToAction
            text="Looking to organise your own event?"
            buttonText="Get in touch"
            link={`/${this.props.locale}/contact-us/organiser-support`}
          />
        </div>
      </Layout>
    );
  }
}

export default CMSComponent(null, SearchResultsPage, 800);
